<template>
    <div>
        <a-row>
            <a-col :span="12">
                <a-form :form="form" v-bind="formItemLayout" class="mt">
                    <a-form-item label="Template Name">
                        <a-input
                           :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            v-decorator="[
                              'templateName',
                              { initialValue: oldEditVal.templateName }
                            ]"/>
                    </a-form-item>
                    <a-form-item label="Jasper File">
                        <a-row type="flex" justify="start">
                            <a-col>{{oldEditVal.fileName}}</a-col>
                            <a-col class="ml4">
                                <a-upload
                                        name="file"
                                        :showUploadList="false"
                                        :customRequest="customRequest"
                                        :headers="headers"
                                        :data="uploadData"
                                        method="post"
                                >
                                    <a-tooltip placement="topLeft">
                                        <template slot="title">
                                            <span>Upload</span>
                                        </template>
                                        <a-button type="primary" shape="circle" icon="upload" size="small"/>
                                    </a-tooltip>
                                </a-upload>
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>Download</span>
                                    </template>
                                    <a-button v-if="oldEditVal.fileName" type="primary" shape="circle" icon="download" size="small" @click='downloadTml' class="ml4"/>
                                </a-tooltip>
                            </a-col>
                        </a-row>
                    </a-form-item>

                    <a-form-item label="Jrxml File">
                        <a-row type="flex" justify="start">
                            <a-col>{{oldEditVal.jrxmlFileName}}</a-col>
                            <a-col class="ml4">
                                <a-upload
                                        name="file"
                                        :showUploadList="false"
                                        :customRequest="customRequestJrxml"
                                        :headers="headers"
                                        :data="uploadData"
                                        method="post"
                                >
                                    <a-tooltip placement="topLeft">
                                        <template slot="title">
                                            <span>Upload</span>
                                        </template>
                                        <a-button type="primary" shape="circle" icon="upload" size="small"/>
                                    </a-tooltip>
                                </a-upload>
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>Download</span>
                                    </template>
                                    <a-button v-if="oldEditVal.jrxmlFileName" @click='downloadJrxml' type="primary" shape="circle" icon="download" size="small" class="ml4"/>
                                </a-tooltip>
                            </a-col>
                        </a-row>
                    </a-form-item>

                    <a-form-item label="Is Main">
                        <a-switch
                          size="small"
                          v-decorator="[
                          'isMain',
                          { initialValue: oldEditVal.isMain == '1' ? true : false ,valuePropName: 'checked' }
                        ]"/>
                    </a-form-item>
                    <a-form-item label="Remark">
                        <a-textarea
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                :rows="4"
                                v-decorator="[
                              'remark',
                              { initialValue: oldEditVal.remark }
                            ]"/>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-row>
            <a-button type="primary" size="small" class="fr mr10" @click="saveTml">Save</a-button>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import axios from 'axios'
    import cookie from "../../../../api/cookie";
    export default{
        props:{
            dataSourceRow: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            headerUid:{
                type: String,
                default: function() {
                    return '';
                }
            }
        },
        data(){
            return{
                headers: {
                    "Authorization": cookie.getBearerToken()
                },
                action: '',
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                form: this.$form.createForm(this),
                oldEditVal: {},
                uploadData:{}
            }
        },
        watch:{
            dataSourceRow(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                if(this.dataSourceRow.uid){
                    this.form.resetFields();
                    ajax.get(api.REPORTGENERICCONFIGIREPORT,{uid: this.dataSourceRow.uid}).then(res=>{
                        this.oldEditVal = res.data
                    })
                }
            },
            saveTml(){
                if(this.oldEditVal.fileName == ''){
                    this.$customMessage.warning('Jasper File Please upload');
                    return
                }
                if(this.oldEditVal.jrxmlFileName == ''){
                    this.$customMessage.warning('Jrxml File Please upload');
                    return
                }
                this.form.validateFields((error, values)=>{
                    if(!error){
                        values.isMain = values.isMain ? '1' : '0'
                        values.uid = this.dataSourceRow.uid
                        values.rtMasterUid = this.headerUid
                        ajax.post(api.REPORTGENERICCONFIGIREPORT,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.$emit('emitTmlEdit',this.dataSourceRow)
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
//            jasper 上传下载
            downloadTml(){
                let ajaxurl = ajax.ajaxUrl();
                axios.get(ajaxurl + api.REPORTGENERICCONFIGJASPEPRDOWNLOAD, {
                    params: {
                        uid:this.dataSourceRow.uid,
                    },
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", this.oldEditVal.fileName);
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            },
            customRequest(data){
                const formData = new FormData()
                formData.append('file', data.file)
                formData.append('uid', this.dataSourceRow.uid)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.REPORTGENERICCONFIGJASPERUPLOAD,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.$message.success(res.msg);
                        this.init()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
//            Jrxml 上传下载
            customRequestJrxml(data){
                const formData = new FormData()
                formData.append('file', data.file)
                formData.append('uid', this.dataSourceRow.uid)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.REPORTGENERICCONFIGJRXMLUPLOAD,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.$message.success(res.msg);
                        this.init()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            downloadJrxml(){
                let ajaxurl = ajax.ajaxUrl();
                axios.get(ajaxurl + api.REPORTGENERICCONFIGJRXMLDOWNLOAD, {
                    params: {
                        uid:this.dataSourceRow.uid,
                    },
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", this.oldEditVal.jrxmlFileName);
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            },
        }
    }
</script>